'use client'

import { ReactNode, useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

import DialogComponent from '@/components/Context/DialogProvider/Dialog'
import { ModalTrigger } from '@/types/ContentModel/ContentModelBox'

export default function Dialog({ trigger, id, children }: { trigger: ModalTrigger; id: string; children: ReactNode }) {
  const [dialog, setDialog] = useState<boolean>(false)
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0,
  })

  useEffect(() => {
    const localStorageKey = `contentModelDialog.${id}`

    if (trigger == 'inView' && inView && !dialog && localStorage.getItem(localStorageKey) == null) {
      setDialog(true)
      localStorage.setItem(localStorageKey, id)
    }
  }, [inView])

  return (
    <>
      <div ref={ref} />
      <DialogComponent show={dialog} afterSubmit={() => setDialog(false)} key={dialog.toString()} controlScroll={false}>
        {children}
      </DialogComponent>
    </>
  )
}
